import API from "./API";

export default class Tickets extends API
{
    static async create(params, fields) {
        return this.post("api/admin/tickets", params);
    }    
    
}